<div class="h-full bg-white border-l border-gray-200 flex flex-col">
  <!-- ========== HEADER Y SIGNOS VITALES: Solo visible en vista de perfil ========== -->
  <ng-container *ngIf="currentPatient && vistaActual === 'perfil'">
    <!-- Header con imagen de fondo -->
    <div class="relative overflow-hidden border border-gray-200 bg-gray-100">
      <!-- Imagen del paciente -->
      <div class="w-full h-52 sm:h-64 md:h-72 flex items-center justify-center">
        <img
          [src]="patientPhotoUrl"
          alt="Foto del paciente"
          class="w-full h-full object-contain"
        />
      </div>

      <!-- Capa de BLUR con máscara gradiente derecha→izquierda -->
      <div
        class="pointer-events-none absolute inset-0 backdrop-blur-sm sm:backdrop-blur-md lg:backdrop-blur-lg [mask-image:linear-gradient(90deg,transparent_45%,black_70%)] [-webkit-mask-image:linear-gradient(90deg,transparent_45%,black_70%)]"
      ></div>

      <!-- (Opcional) Capa de oscurecido gradiente derecha→izquierda -->
      <div
        class="pointer-events-none absolute inset-0 bg-gradient-to-l from-black/40 via-black/20 to-transparent"
      ></div>

      <div class="absolute inset-0 grid grid-cols-2 gap-2 p-3 sm:p-4">
        <!-- MODAL: Crear / Editar nota -->
        <div *ngIf="modalNotaAbierta" class="fixed inset-0 z-[1200] grid place-items-center p-4">
          <div class="absolute inset-0 bg-black/40" (click)="modalNotaAbierta = false"></div>

          <section
            class="relative z-10 w-full max-w-lg rounded-2xl bg-white ring-1 ring-black/5 shadow-lg p-5"
            (click)="$event.stopPropagation()"
          >
            <header class="flex items-center justify-between mb-3">
              <div>
                <h3 class="text-lg font-semibold">{{ editingNotaId ? 'Editar nota' : 'Nueva nota' }}</h3>
                <p class="text-xs text-slate-500">Título y contenido de la nota (visible solo en la cita).</p>
              </div>
              <button class="text-sm text-slate-500" (click)="modalNotaAbierta = false">Cerrar</button>
            </header>

            <div class="space-y-3">
              <input
                type="text"
                class="w-full border rounded px-3 py-2"
                placeholder="Título"
                [(ngModel)]="notaForm.titulo"
              />

              <textarea
                class="w-full border rounded px-3 py-2 min-h-[8rem] text-sm"
                placeholder="Escribe la nota..."
                [(ngModel)]="notaForm.nota"
              ></textarea>

              <div class="flex justify-between items-center">
                <div class="text-xs text-slate-500">
                  {{ editingNotaId ? 'Editando nota' : 'Crear nueva nota' }}
                </div>

                <div class="flex gap-2">
                  <button class="px-3 py-1 rounded bg-gray-100" (click)="modalNotaAbierta = false">Cancelar</button>

                  <button class="px-3 py-1 rounded bg-emerald-600 text-white" (click)="guardarNota()">
                    {{ editingNotaId ? 'Guardar cambios' : 'Crear nota' }}
                  </button>

                  <button
                    *ngIf="editingNotaId"
                    class="px-3 py-1 rounded bg-red-100 text-red-700"
                    (click)="eliminarNota(editingNotaId); modalNotaAbierta = false"
                  >
                    Eliminar
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>
        <!-- Columna IZQUIERDA: Notas internas (arriba) + Particular (abajo) -->
        <div class="relative">
          <div class="relative inline-flex items-center gap-2 cursor-pointer" (click)="openNotasModal()">
            <!-- Badge rojo con contador de notas nuevas (no leídas) -->
            <span
              *ngIf="notasNuevasCount > 0"
              class="absolute -top-2 -right-2 z-10 flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[10px] font-bold text-white bg-red-500 rounded-full shadow-sm animate-pulse"
            >
              {{ notasNuevasCount }}
            </span>
            <span
              class="pl-3 pr-1 py-1 rounded-full text-[11px] sm:text-xs font-medium bg-white/75 backdrop-blur text-gray-800"
            >
              Notas internas
              <button class="px-2 py-1 rounded-full text-[11px] sm:text-xs bg-white/75 backdrop-blur text-gray-800">
                <!-- Ícono de documento con lápiz -->
                <svg class="w-3 h-3 inline-block" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14 2V8H20"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12 18V12"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 15L12 12L15 15"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </span>
          </div>
          <span
            class="absolute bottom-0 left-0 px-3 py-1 rounded-full text-[11px] sm:text-xs font-medium bg-[#BFEBF5]/50 backdrop-blur text-white"
          >
            {{ currentPatient.insurance_name || 'NA' }}
          </span>
        </div>

        <!-- Columna DERECHA: Sexo, Edad, Estatura, Peso -->
        <div class="flex flex-col justify-center items-end gap-1 sm:gap-2">
          <div class="text-white/90 text-xs sm:text-sm">Sexo</div>
          <div class="px-3 py-1 rounded-full bg-[#D2BFF5]/50 text-white text-xs sm:text-sm font-medium backdrop-blur">
            {{ currentPatient.gender || '-' }}
          </div>

          <div class="mt-1 text-white/90 text-xs sm:text-sm">Edad</div>
          <div class="px-3 py-1 rounded-full bg-[#D2BFF5]/50 text-white text-xs sm:text-sm font-medium backdrop-blur">
            {{ getAge(currentPatient.birth_date ?? undefined, true) || '-' }}
          </div>

          <div class="mt-1 text-white/90 text-xs sm:text-sm">Estatura</div>
          <div class="px-3 py-1 rounded-full bg-[#D2BFF5]/50 text-white text-xs sm:text-sm font-medium backdrop-blur">
            {{ tallaSignosVitales }}
          </div>

          <div class="mt-1 text-white/90 text-xs sm:text-sm">Peso</div>
          <div class="px-3 py-1 rounded-full bg-[#D2BFF5]/50 text-white text-xs sm:text-sm font-medium backdrop-blur">
            {{ pesoSignosVitales }}
          </div>
        </div>
      </div>
    </div>

    <!-- Acordeón agrupado -->
    <div class="bg-violet-100/70 overflow-hidden">
    <!-- Header -->
    <button
      type="button"
      (click)="svOpen = !svOpen"
      class="w-full px-3 sm:px-4 py-2 sm:py-3"
      [attr.aria-expanded]="svOpen ? 'true' : 'false'"
      [attr.aria-controls]="'sv-panel'"
    >
      <div
        class="grid items-center gap-2 sm:gap-3"
        [style.gridTemplateColumns]="'28px repeat(' + headerCount + ', minmax(0,1fr))'"
      >
        <!-- Col 1 -->
        <div class="flex items-center justify-center">
          <div
            class="w-6 h-6 rounded-full bg-white/80 text-slate-700 flex items-center justify-center transition-transform duration-300"
            [class.rotate-180]="svOpen"
            aria-hidden="true"
          >
            <!-- Chevron icon -->
            <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>

        <ng-container *ngFor="let signo of signosVitales | slice : 0 : headerCount">
          <div class="flex flex-col items-center text-center">
            <div class="relative w-full rounded-2xl p-px sm:p-[1.5px]">
              <div class="rounded-2xl w-full h-full flex items-center justify-center">
                <svg class="max-w-8 max-h-8" fill="none" viewBox="0 0 50 50">
                  <ng-container *ngIf="!Array.isArray(signo.icono); else multiPath">
                    <path [attr.d]="signo.icono" fill="#1A3C60" />
                  </ng-container>
                  <ng-template #multiPath>
                    <path *ngFor="let d of signo.icono" [attr.d]="d" fill="#1A3C60" />
                  </ng-template>
                </svg>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </button>

    <!-- Contenido expandible  -->
    <div
      class="transition-all duration-300 ease-in-out overflow-hidden"
      [class.max-h-0]="!svOpen"
      [ngClass]="{ 'max-h-[999px]': svOpen }"
    >
      <div class="px-3 sm:px-4 pb-3 sm:pb-4">
        <div
          class="grid items-center gap-2 sm:gap-3"
          [style.gridTemplateColumns]="'28px repeat(' + headerCount + ', minmax(0,1fr))'"
        >
          <!-- Col 1 -->
          <div></div>

          <!-- Cols 2 -->
          <ng-container *ngFor="let signo of signosVitales | slice : 0 : 4; let i = index">
            <div class="flex flex-col items-center text-center">
              <div class="hidden relative w-full rounded-2xl p-px sm:p-[1.5px]">
                <div class="rounded-2xl w-full h-full flex items-center justify-center">
                  <svg class="max-w-8 max-h-8" fill="none" viewBox="0 0 50 50">
                    <ng-container *ngIf="!Array.isArray(signo.icono); else multiPath">
                      <path [attr.d]="signo.icono" fill="#1A3C60" />
                    </ng-container>
                    <ng-template #multiPath>
                      <path *ngFor="let d of signo.icono" [attr.d]="d" fill="#1A3C60" />
                    </ng-template>
                  </svg>
                </div>
              </div>
              <div
                class="text-[10px] sm:text-xs text-gray-600 leading-snug overflow-hidden transition-all duration-300"
              >
                <span class="mt-1 text-[10px] sm:text-xs text-gray-700 leading-tight line-clamp-2">
                  {{ signo.nombre }}
                </span>
                <span class="font-semibold text-gray-900">
                  {{ signo.valor }} <span class="text-xs">{{ signo.unidad }}</span>
                </span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="absolute w-[-webkit-fill-available] bottom-0 z-50 flex pointer-events-none">
      <div
        class="pointer-events-auto bg-white/95 backdrop-blur-sm border border-gray-200 px-4 py-2 w-full max-w-full mx-auto"
      >
        <!-- Fila única: Médico referidor y Cita -->
        <div class="text-md text-[#1A3C60] bg-[#9199AE]/10 py-1 flex items-center gap-4">
          <span>Médico: {{ appointmentDoctorName || '—' }}</span>
          <span class="hidden sm:inline">|</span>
          <span>Cita: {{ appointmentTimeDisplay || '—' }}</span>
          <button
            type="button"
            class="ml-auto historico-btn"
            (click)="abrirModalHistoricoPdf()"
          >
            Historico
          </button>
        </div>
      </div>
    </div>
  </div>
  </ng-container>

  <!-- ========== BACK BUTTON: Solo visible en vista de resumen ========== -->
  <div *ngIf="vistaActual === 'resumen'" class="bg-gradient-to-r from-purple-50 to-white border-b border-purple-100 px-6 py-4">
    <button
      (click)="cambiarVista('perfil')"
      class="group flex items-center gap-3 px-4 py-2.5 bg-white hover:bg-purple-50 border-2 border-purple-200 hover:border-primary-500 rounded-xl shadow-sm hover:shadow-md transition-all duration-200"
    >
      <div class="w-8 h-8 rounded-full bg-purple-100 group-hover:bg-primary-500 flex items-center justify-center transition-colors duration-200">
        <svg class="w-4 h-4 text-primary-600 group-hover:text-white transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
        </svg>
      </div>
      <span class="text-sm font-semibold text-gray-800 group-hover:text-primary-600 transition-colors duration-200">
        Volver al Perfil del Paciente
      </span>
    </button>
  </div>

  <!-- Scrollable Content -->
  <div class="flex-1 pb-20 overflow-y-auto scrollbar-thin">
    <!-- ========== PERFIL VIEW ========== -->
    <div
      *ngIf="vistaActual === 'perfil' && currentPatient"
      [@fadeSlide]="vistaActual"
      class="px-6 pt-1 pb-6 space-y-4"
    >
      <!-- Nota Interna -->
      <div class="hidden bg-yellow-50 border border-yellow-200 rounded-lg p-4">
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-sm font-semibold text-yellow-800">Nota Interna</h3>
          <button (click)="editarNota()" class="text-xs text-yellow-600 hover:text-yellow-700 font-medium">
            Editar
          </button>
        </div>
        <textarea
          [(ngModel)]="notaInterna"
          class="w-full text-sm text-yellow-800 bg-transparent resize-none border-none focus:ring-0 p-0"
          rows="3"
          readonly
        >
        </textarea>
      </div>

      <!-- Diagnosticos actuales (CIE-11) -->
      <div class="p-2 bg-white">
        <div class="flex items-center gap-3 mb-2">
          <h4 class="text-xl font-semibold text-slate-800">Diagnósticos</h4>
        </div>
        <div *ngIf="isLoadingDiagnosticos" class="text-slate-400 italic text-sm">
          Cargando diagnósticos...
        </div>
        <ng-container *ngIf="!isLoadingDiagnosticos">
          <div *ngIf="diagnosticosActuales && diagnosticosActuales.length > 0" class="flex flex-wrap gap-2">
            <div *ngFor="let dx of diagnosticosActuales" class="group relative">
              <span class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800 border border-purple-200">
                <span *ngIf="dx.fecha_agregado" class="text-purple-500 mr-1">{{ formatFechaDiagnostico(dx.fecha_agregado) }} -</span>
                <span class="font-semibold mr-1">{{ dx.code || dx.codigo || dx.cie10 }}</span>
                <span class="text-purple-600">{{ dx.description || dx.title || dx.descripcion }}</span>
              </span>
            </div>
          </div>
          <div *ngIf="!diagnosticosActuales || diagnosticosActuales.length === 0" class="text-slate-500 italic text-sm">
            No hay diagnósticos registrados
          </div>
        </ng-container>
      </div>

      <div *ngIf="citaSeleccionada">
        <ng-container [ngSwitch]="citaSeleccionada.type">
          <app-primera-vez *ngSwitchCase="'1N'" [appointment]="citaSeleccionada"></app-primera-vez>
          <app-seguimiento *ngSwitchCase="'S'" [appointment]="citaSeleccionada"></app-seguimiento>
          <app-hospitalizacion *ngSwitchCase="'H'" [appointment]="citaSeleccionada"></app-hospitalizacion>
          <div *ngSwitchDefault>
            <p>No hay vista para este tipo de consulta.</p>
          </div>
        </ng-container>
      </div>

      <!-- Componente Histórico -->
      <div class="p-2 bg-white" *ngIf="isLoadingHistorico">
        <div class="flex items-center gap-3 mb-2">
          <h4 class="text-xl font-semibold text-slate-800">Lista de problemas</h4>
        </div>
        <div class="text-slate-400 italic text-sm">
          Cargando lista de problemas...
        </div>
      </div>
      <ng-container *ngIf="!isLoadingHistorico">
        <div #historicoSeccion></div>
        <app-historico
          [tituloSeccion]="'Lista de problemas'"
          [historico]="historico || []"
          [paraclinicosDisponibles]="paraclinicosDisponibles"
          [appointmentId]="appointmentId"
          [patientId]="getValidPatientId()"
          [isLocked]="false"
          (onSave)="saveHistorico($event)"
          (onEventoSeleccionado)="onNotaSeleccionada($event)"
          (onVerParaclinico)="abrirModalVerParaclinico($event)"
        ></app-historico>
      </ng-container>

      <!-- Medicamentos actuales -->
      <div class="p-2 bg-white">
        <div class="flex items-center gap-3 mb-2">
          <h4 class="text-xl font-semibold text-slate-800">Medicamentos actuales</h4>

          <!-- Botón púrpura para abrir modal de indicaciones -->
          <button
            type="button"
            class="inline-flex items-center justify-center w-7 h-7 rounded border border-[#AE91E3] text-[#AE91E3] hover:bg-[#AE91E3] hover:text-white transition-colors duration-200"
            (click)="abrirModalIndicaciones()"
            title="Abrir indicaciones médicas completas"
          >
            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm4 18H6V4h7v5h5v11z" />
              <path d="M8 12h8v2H8zm0 4h8v2H8zm0-8h5v2H8z" />
            </svg>
          </button>
        </div>

        <!-- Lista de medicamentos en formato compacto -->
        <div class="space-y-1 text-sm text-slate-700">
          <!-- Estado: Cargando -->
          <div *ngIf="isLoadingMedicamentos" class="text-slate-400 italic">
            Cargando medicamentos...
          </div>
          <!-- Estado: Contenido (solo cuando NO está cargando) -->
          <ng-container *ngIf="!isLoadingMedicamentos">
            <!-- Recetas disponibles -->
            <div *ngFor="let med of medicamentosCompactos" class="leading-relaxed">
              {{ med }}
            </div>
            <!-- Sin recetas -->
            <div *ngIf="medicamentosCompactos.length === 0" class="text-slate-500 italic">
              No hay medicamentos actuales
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Diagnósticos -->
      <div class="hidden">
        <h3 class="text-lg font-semibold text-gray-900 mb-4">Diagnóstico (CIE-11)</h3>
        <div class="space-y-2">
          <div *ngFor="let diagnostico of diagnosticos" class="bg-red-50 border border-red-200 rounded-lg p-4">
            <div class="flex items-start space-x-3">
              <div class="w-8 h-8 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <svg class="w-4 h-4 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              </div>
              <div>
                <p class="text-sm font-medium text-red-800">
                  {{ diagnostico.codigo }}
                </p>
                <p class="text-sm text-red-700">
                  {{ diagnostico.descripcion }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      *ngIf="vistaActual === 'resumen'"
      [@fadeSlide]="vistaActual"
      class="h-full overflow-hidden"
    >
      <!-- Loading State -->
      <div *ngIf="isLoadingNota && !errorCargaNota" class="flex items-center justify-center py-12">
        <div class="text-center">
          <div class="inline-block animate-spin rounded-full h-12 w-12 border-4 border-primary-200 border-t-primary-600 mb-4"></div>
          <p class="text-sm text-gray-600">Cargando nota médica...</p>
        </div>
      </div>

      <!-- Error State -->
      <div *ngIf="!isLoadingNota && errorCargaNota" class="bg-red-50 border-l-4 border-red-500 p-4 rounded-lg">
        <div class="flex items-start">
          <svg class="h-5 w-5 text-red-600 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          <div class="ml-3">
            <p class="text-sm font-medium text-red-800">Error al cargar la nota</p>
            <p class="text-sm text-red-700 mt-1">{{ errorCargaNota }}</p>
          </div>
        </div>
      </div>

      <!-- Content State -->
      <app-resumen-nota
        *ngIf="!isLoadingNota && !errorCargaNota && notaSeleccionada"
        [nota]="notaSeleccionada"
        [mostrarBotonResumenCompleto]="true"
        (verResumenCompleto)="abrirModalResumenCompleto()"
      ></app-resumen-nota>
    </div>
  </div>

  <!-- MODAL: Historial Completo de Notas Medicas -->
  <div
    *ngIf="modalResumenCompletoAbierto"
    class="fixed inset-0 z-[1300] grid place-items-center p-4 sm:p-6"
  >
    <div class="absolute inset-0 bg-neutral-900/50 backdrop-blur-sm" (click)="cerrarModalResumenCompleto()"></div>
    <section
      class="relative z-10 w-full max-w-7xl h-[92vh] max-h-[92vh] rounded-2xl bg-white ring-1 ring-black/5 shadow-lg flex flex-col"
      role="dialog"
      aria-modal="true"
      (click)="$event.stopPropagation()"
    >
      <header class="flex items-center gap-3 px-6 py-4 bg-gradient-to-br from-purple-50 to-indigo-50 border-b border-black/5">
        <div class="h-9 w-9 grid place-items-center rounded-xl bg-white shadow-sm ring-1 ring-black/5">
          <svg class="h-5 w-5 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
        </div>
        <div class="flex-1">
          <h2 class="text-lg font-semibold text-slate-900">Historial Completo de Notas Medicas</h2>
          <p class="text-sm text-slate-600">
            <ng-container *ngIf="isLoadingResumenCompleto">Cargando notas del paciente...</ng-container>
            <ng-container *ngIf="!isLoadingResumenCompleto">{{ notasResumenCompleto.length }} notas en esta vista</ng-container>
          </p>
        </div>
        <button
          class="inline-flex items-center justify-center rounded-full p-2 text-slate-500 hover:text-slate-700 hover:bg-black/5 transition"
          (click)="cerrarModalResumenCompleto()"
          aria-label="Cerrar"
        >
          <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M6 6l12 12M18 6L6 18" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>
      </header>

      <div class="flex-1 min-h-0 overflow-y-auto bg-slate-50/60">
        <div class="p-4 md:p-6">
          <div *ngIf="isLoadingResumenCompleto" class="flex items-center justify-center py-16">
            <div class="text-center">
              <div class="inline-block animate-spin rounded-full h-12 w-12 border-4 border-primary-200 border-t-primary-600 mb-4"></div>
              <p class="text-sm text-slate-600">Cargando historial completo...</p>
            </div>
          </div>

          <div *ngIf="!isLoadingResumenCompleto && errorResumenCompleto" class="rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-700">
            {{ errorResumenCompleto }}
          </div>

          <div *ngIf="!isLoadingResumenCompleto && !errorResumenCompleto && notasResumenCompleto.length === 0" class="rounded-xl border border-slate-200 bg-white p-6 text-sm text-slate-600">
            No hay notas medicas disponibles para este paciente.
          </div>

          <div *ngIf="!isLoadingResumenCompleto && !errorResumenCompleto && notasResumenCompleto.length > 0" class="space-y-6">
            <article
              *ngFor="let nota of notasResumenCompleto; let i = index; trackBy: trackByNotaResumenCompleto"
              #notaCardResumenCompleto
              [attr.data-nota-id]="nota?.id || null"
              [ngClass]="esNotaActualEnResumenCompleto(nota) ? 'overflow-hidden rounded-2xl border border-indigo-300 ring-2 ring-indigo-200 bg-white shadow-sm' : 'overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm'"
            >
              <div class="px-5 py-2.5 text-xs text-slate-600 bg-slate-50 border-b border-slate-200 flex items-center justify-between">
                <span class="inline-flex items-center gap-2">
                  <span>Nota {{ i + 1 }} de {{ notasResumenCompleto.length }}</span>
                  <span *ngIf="esNotaActualEnResumenCompleto(nota)" class="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold border border-indigo-200 bg-indigo-100 text-indigo-700">
                    Nota actual
                  </span>
                </span>
                <span>{{ (nota?.created_at || nota?.fecha) | date : 'dd/MM/yyyy HH:mm' }}</span>
              </div>

              <app-resumen-nota
                class="block"
                [nota]="nota"
                [mostrarBotonResumenCompleto]="false"
                [usarScrollInterno]="false"
                [esVistaModal]="true"
              ></app-resumen-nota>
            </article>
          </div>
        </div>
      </div>
    </section>
  </div>

  <!-- MODAL: Indicaciones Médicas Completas -->
  <div
    *ngIf="modalIndicacionesAbierto"
    class="fixed inset-0 z-[9999] flex items-center justify-center p-4"
    (click)="cerrarModalIndicaciones()"
  >
    <!-- Backdrop con z-index alto para cubrir sticky headers -->
    <div class="absolute inset-0 bg-black/40 backdrop-blur-sm z-[9998]"></div>

    <!-- Modal Container -->
    <div
      class="relative z-[10000] w-full max-w-5xl max-h-[90vh] bg-white rounded-2xl shadow-2xl overflow-hidden"
      (click)="$event.stopPropagation()"
    >
      <!-- Modal Body - Scrollable -->
      <div class="h-full overflow-y-auto p-6">
        <!-- Botón cerrar flotante en esquina superior derecha -->
        <button
          type="button"
          class="absolute top-4 right-4 z-10 text-gray-400 hover:text-gray-600 transition-colors"
          (click)="cerrarModalIndicaciones()"
        >
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        <!-- Componente de Indicaciones (ya tiene su propio título) -->
        <app-indicaciones
          [indicacionesMedicas]="indicacionesMedicas"
          [plantillasRecetas]="plantillasRecetas"
          [isLocked]="false"
          (onSave)="saveIndicaciones($event)"
          (onSavePlantilla)="savePlantillaReceta($event)"
          (onUpdatePlantilla)="updatePlantillaReceta($event)"
          (onDeletePlantilla)="deletePlantillaReceta($event)"
        ></app-indicaciones>
      </div>
    </div>
  </div>

  <!-- MODAL: Notas Internas del Paciente -->
  <app-notas-internas-modal
    *ngIf="showNotasModal"
    [patient]="currentPatient"
    [notas]="notasInternas"
    (close)="closeNotasModal()"
    (guardarNota)="handleGuardarNota($event)"
  ></app-notas-internas-modal>

  <div
    *ngIf="modalHistoricoPdfAbierto"
    class="fixed inset-0 z-[1300] grid place-items-center p-4 sm:p-6"
  >
    <div class="absolute inset-0 bg-neutral-900/50 backdrop-blur-sm" (click)="cerrarModalHistoricoPdf()"></div>
    <section
      class="relative z-10 w-full max-w-5xl rounded-2xl bg-white ring-1 ring-black/5 shadow-lg flex flex-col max-h-[90vh]"
      role="dialog"
      aria-modal="true"
      (click)="$event.stopPropagation()"
    >
      <header class="flex items-center gap-3 px-6 py-4 bg-gradient-to-br from-blue-50 to-indigo-50 border-b border-black/5">
        <div class="h-9 w-9 grid place-items-center rounded-xl bg-white shadow-sm ring-1 ring-black/5">
          <svg class="h-5 w-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
            />
          </svg>
        </div>
        <div class="flex-1">
          <h2 class="text-lg font-semibold text-slate-900">Historico de PDFs</h2>
          <p *ngIf="historicoPdfVista === 'lista'" class="text-sm text-slate-600">Sube y consulta archivos PDF del paciente</p>
          <p *ngIf="historicoPdfVista === 'visor'" class="text-sm text-slate-600 truncate">{{ historicoPdfSeleccionado?.file_name || 'Visualizador PDF' }}</p>
        </div>
        <button
          class="inline-flex items-center justify-center rounded-full p-2 text-slate-500 hover:text-slate-700 hover:bg-black/5 transition"
          (click)="cerrarModalHistoricoPdf()"
          aria-label="Cerrar"
        >
          <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M6 6l12 12M18 6L6 18" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>
      </header>

      <div *ngIf="historicoPdfVista === 'lista'" class="p-6 overflow-y-auto flex-1 space-y-4">
        <div class="rounded-xl border border-slate-200 bg-slate-50 p-4 space-y-3">
          <div class="flex flex-wrap items-center gap-3">
            <input
              type="file"
              accept="application/pdf,.pdf"
              (change)="onArchivoHistoricoPdfChange($event)"
              class="hidden"
              id="historicoPdfInput"
            />
            <label
              for="historicoPdfInput"
              class="inline-flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-semibold bg-[#AE91E3] text-white hover:bg-[#9b7cd1] transition cursor-pointer"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
              </svg>
              Seleccionar PDF
            </label>

            <span *ngIf="subiendoHistoricoPdf" class="inline-flex items-center gap-2 text-sm text-slate-600">
              <svg class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4l3.5-3.5L12 1v3a8 8 0 00-8 8z"></path>
              </svg>
              Subiendo...
            </span>
          </div>

          <div *ngIf="archivoHistoricoPdf" class="flex items-center justify-between gap-3 rounded-lg bg-white border border-slate-200 px-3 py-2">
            <div class="min-w-0">
              <p class="text-sm font-medium text-slate-800 break-words">{{ archivoHistoricoPdf.name }}</p>
              <p class="text-xs text-slate-500">{{ formatFileSize(archivoHistoricoPdf.size) }}</p>
            </div>
            <button
              type="button"
              class="p-1 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded transition"
              (click)="limpiarArchivoHistoricoPdf()"
              title="Quitar archivo"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <p *ngIf="errorHistoricoPdf" class="text-sm text-red-600">{{ errorHistoricoPdf }}</p>
        </div>

        <div class="rounded-xl border border-slate-200 overflow-hidden">
          <div class="px-4 py-3 bg-slate-50 border-b border-slate-200 flex items-center justify-between">
            <h3 class="text-sm font-semibold text-slate-800">Archivos cargados</h3>
            <span class="text-xs text-slate-500">{{ historicoPdfs.length }}</span>
          </div>

          <div *ngIf="isLoadingHistoricoPdfs" class="px-4 py-6 text-sm text-slate-500 italic">Cargando...</div>

          <div *ngIf="!isLoadingHistoricoPdfs && historicoPdfs.length === 0" class="px-4 py-6 text-sm text-slate-500 italic">
            Sin datos
          </div>

          <div *ngIf="!isLoadingHistoricoPdfs && historicoPdfs.length > 0" class="p-4 space-y-3">
            <div *ngFor="let pdf of historicoPdfs" class="paraclinico-floating-card">
              <div class="paraclinico-icon" (click)="abrirPdfHistorico(pdf)">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
              </div>

              <div class="paraclinico-info" (click)="abrirPdfHistorico(pdf)">
                <div class="paraclinico-fecha">{{ pdf.created_at | date : 'dd/MM/yyyy HH:mm' }}</div>
                <div class="paraclinico-nombre break-words">{{ pdf.file_name }}</div>
                <div class="paraclinico-interpretacion">{{ formatFileSize(pdf.file_size) }}</div>
              </div>

              <div class="paraclinico-tipo">
                <span class="tipo-badge laboratorio">PDF</span>
              </div>

              <div class="paraclinico-acciones">
                <button
                  type="button"
                  class="btn-accion btn-ver"
                  (click)="abrirPdfHistorico(pdf); $event.stopPropagation()"
                  title="Ver PDF"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke-linecap="round" stroke-linejoin="round"/>
                    <circle cx="12" cy="12" r="3" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>

                <button
                  type="button"
                  class="btn-accion btn-eliminar"
                  (click)="eliminarHistoricoPdf(pdf); $event.stopPropagation()"
                  title="Eliminar PDF"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="historicoPdfVista === 'visor'" class="p-6 overflow-y-auto flex-1 space-y-4">
        <div class="flex items-center justify-between gap-3">
          <button
            type="button"
            class="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-slate-200 text-slate-700 hover:bg-slate-50 transition"
            (click)="volverAListaHistoricoPdf()"
          >
            <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M15 19l-7-7 7-7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Volver a lista
          </button>
          <div class="text-right text-xs text-slate-500">
            <div>{{ historicoPdfSeleccionado?.created_at | date : 'dd/MM/yyyy HH:mm' }}</div>
            <div>{{ formatFileSize(historicoPdfSeleccionado?.file_size) }}</div>
          </div>
        </div>

        <div *ngIf="historicoPdfSeleccionado?.file_url_safe || historicoPdfSeleccionado?.file_url" class="border rounded-lg overflow-hidden w-full">
          <img
            *ngIf="esImagenHistoricoPdfSeleccionado()"
            [src]="historicoPdfSeleccionado?.file_url"
            class="w-full max-h-[70vh] object-contain bg-gray-100"
            alt="Documento del paciente"
          />
          <iframe
            *ngIf="!esImagenHistoricoPdfSeleccionado()"
            [src]="historicoPdfSeleccionado?.file_url_safe"
            class="w-full h-[70vh] min-h-[520px]"
          ></iframe>
        </div>

        <div
          *ngIf="!historicoPdfSeleccionado?.file_url_safe && !historicoPdfSeleccionado?.file_url"
          class="border-2 border-dashed border-gray-300 rounded-lg w-full h-[420px] flex items-center justify-center"
        >
          <div class="text-center text-gray-400">
            <svg class="w-16 h-16 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
              />
            </svg>
            <p>No hay documento disponible</p>
          </div>
        </div>
      </div>

      <footer class="px-6 py-4 border-t border-slate-200 bg-white/90 backdrop-blur flex items-center justify-between gap-3">
        <a
          *ngIf="historicoPdfVista === 'visor' && historicoPdfSeleccionado?.file_url"
          [href]="historicoPdfSeleccionado?.file_url"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold bg-slate-100 text-slate-700 hover:bg-slate-200 transition"
        >
          <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M14 3h7v7m0-7L10 14m-3-7H3v14h14v-4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          Abrir en nueva pestana
        </a>
        <span *ngIf="historicoPdfVista !== 'visor'"></span>
        <button
          type="button"
          class="px-4 py-2 rounded-lg border border-slate-200 text-slate-700 hover:bg-slate-50 transition"
          (click)="cerrarModalHistoricoPdf()"
        >
          Cerrar
        </button>
      </footer>
    </section>
  </div>

  <!-- MODAL: Ver Paraclínico (desde histórico) - Pantalla completa -->
  <div
    *ngIf="modalVerParaclinicoAbierto"
    class="fixed inset-0 z-[1300] grid place-items-center p-4 sm:p-6"
  >
    <div class="absolute inset-0 bg-neutral-900/50 backdrop-blur-sm" (click)="cerrarModalVerParaclinico()"></div>
    <section
      class="relative z-10 w-full max-w-7xl rounded-2xl bg-white ring-1 ring-black/5 shadow-lg flex flex-col max-h-[90vh]"
      role="dialog"
      aria-modal="true"
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->
      <div class="px-6 py-3 bg-gradient-to-br from-purple-50 to-indigo-50 border-b border-black/5 flex-shrink-0">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <div class="h-8 w-8 grid place-items-center rounded-xl bg-white shadow-sm ring-1 ring-black/5">
              <svg class="h-4 w-4 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </div>
            <div class="flex items-baseline gap-3">
              <h2 class="text-lg font-semibold text-slate-900">{{ paraclinicoParaVer?.nombre || 'Paraclínico' }}</h2>
              <span class="text-sm text-slate-600">{{
                paraclinicoParaVer?.fecha ? (paraclinicoParaVer?.fecha | date : 'dd/MM/yyyy') : 'Sin fecha'
              }}</span>
            </div>
          </div>
          <button
            class="inline-flex items-center justify-center rounded-full p-2 text-slate-500 hover:text-slate-700 hover:bg-black/5 transition"
            (click)="cerrarModalVerParaclinico()"
            aria-label="Cerrar"
          >
            <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M6 6l12 12M18 6L6 18" stroke-width="2" stroke-linecap="round" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Body -->
      <div class="p-6 overflow-y-auto flex-1 space-y-3">
        <!-- Interpretación -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Interpretación</label>
          <div class="border border-gray-300 rounded-lg overflow-hidden quill-wrapper">
            <quill-editor
              [(ngModel)]="paraclinicoParaVer!.interpretacion"
              placeholder="Escribe tus notas o interpretación aquí..."
              spellcheck="true"
            ></quill-editor>
          </div>
        </div>

        <!-- Documento del estudio -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Documento del estudio</label>
          <div *ngIf="paraclinicoParaVer?.pdfUrlSafe || paraclinicoParaVer?.pdfUrl" class="border rounded-lg overflow-hidden w-full">
            <!-- Si es imagen, mostrar con <img> -->
            <img
              *ngIf="esImagenParaclinicoVer()"
              [src]="paraclinicoParaVer?.pdfUrl"
              class="w-full max-h-[580px] object-contain bg-gray-100"
              alt="Imagen del estudio"
            />
            <!-- Si es PDF, mostrar con <iframe> -->
            <iframe
              *ngIf="!esImagenParaclinicoVer()"
              [src]="paraclinicoParaVer?.pdfUrlSafe"
              class="w-full h-[580px]"
            ></iframe>
          </div>
          <div
            *ngIf="!paraclinicoParaVer?.pdfUrlSafe && !paraclinicoParaVer?.pdfUrl"
            class="border-2 border-dashed border-gray-300 rounded-lg w-full h-[580px] flex items-center justify-center"
          >
            <div class="text-center text-gray-400">
              <svg class="w-16 h-16 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                />
              </svg>
              <p>No hay documento disponible</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="px-6 py-4 bg-white/90 backdrop-blur border-t border-slate-200 flex items-center justify-end gap-3">
        <button
          *ngIf="paraclinicoParaVer?.pdfUrl"
          type="button"
          class="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-green-600 text-white hover:bg-green-700 transition mr-auto"
          (click)="compartirParaclinicoPorWhatsapp(paraclinicoParaVer?.pdfUrl)"
        >
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
            <path
              d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"
            />
          </svg>
          Compartir por WhatsApp
        </button>
        <button
          type="button"
          class="px-4 py-2 rounded-lg border border-slate-200 text-slate-700 hover:bg-slate-50 transition"
          (click)="cerrarModalVerParaclinico()"
        >
          Cerrar
        </button>
        <button
          type="button"
          class="px-5 py-2.5 rounded-xl text-sm font-semibold bg-[#AE91E3] text-white hover:bg-[#9b7cd1] transition"
          (click)="cerrarModalVerParaclinico()"
        >
          Guardar Cambios
        </button>
      </div>
    </section>
  </div>
</div>

